import { Box, Card, Grid, Modal, Typography } from '@mui/material';
import MDButton from 'components/MDButton';

// import { colorScheme } from 'default';
import React from 'react';
import HelpIcon from '@mui/icons-material/Help';



const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    display: 'grid',
    justifyContent: 'center'
};

function BillingModal({ ...props }) {
    return (
        <Modal
            open={props.open}
            onClose={props.closeModalClick}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description" >

            <Card sx={style}>
                <Box>
                    <Typography id="modal-modal-title" variant="h6" component="h2" style={{ fontSize: "40px", textAlign: "center" }}>
                        <HelpIcon style={{ color: "red" }} />
                    </Typography>
                    <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black", textAlign: "center" }}>
                        {`${props.title}`}
                    </Typography>
                    <Typography variant="h6" component="p" style={{ color: "black", textAlign: "center" }}>
                        {`${props.message}`}
                    </Typography>
                    <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                        <MDButton color="warning" onClick={props.handleCancel} style={{ width: "64px", textTransform: "capitalize" }}>
                            No
                        </MDButton>
                        &nbsp; &nbsp;
                        <MDButton color="success" onClick={props.handleConfirm} style={{ width: "64px", textTransform: "capitalize" }}>
                            Yes
                        </MDButton>
                    </Grid>
                </Box>
            </Card>
        </Modal>

    );
}

export default BillingModal;
